import { useMutation } from 'react-query';
import {
  createDeviceStream,
  deleteDeviceByIdAsync,
  getAllCamsByLicenseAsync,
  getAllCamsByLicenseCountAsync,
  getAllControllersByLicenseAsync,
  getAllControllersByLicenseCountAsync,
  getAllDevicesByLicenseAsync,
  getAllDevicesByLicenseCountAsync,
  getAllDevicesByLicenseInfoAsync,
  getAllDvrByLicenseAsync,
  getAllDvrByLicenseCountAsync,
  getAllInternalFacesFromDeviceAsync,
  getAllInternalFacesFromDeviceCountAsync,
  getDeviceByIdAsync,
  getLostAlarmEventsConfigAsync,
  getLprGroupsConfigAsync,
  getNetworkConfigAsync,
  getNtpConfigAsync,
  getRecordingScheduleConfigAsync,
  getRecoverEventConfigAsync,
  getTimeConfigAsync,
  getVideoConfigAsync,
  openDoor,
  updateLprGroupsConfigAsync,
  updateNetworkConfigAsync,
  updateNtpConfigAsync,
  updateRecordingScheduleConfigAsync,
  updateRecoverEventConfigAsync,
  updateStatusDeviceAsync,
  updateTimeConfigAsync,
  updateVideoConfigAsync,
  createDeviceAsync,
  updateDeviceAsync,
  updateDeviceExternalControlIdAsync,
  syncDeviceModuleHistoryAsync,
  getFacialSyncSelectableDevicesAsync,
  syncFacialRecognitionDevicesAsync,
} from '../../index';

export const useUpdateStatusDeviceAsync = () =>
  useMutation(updateStatusDeviceAsync);

export const useCreateDeviceStream = () => useMutation(createDeviceStream);

export const useGetDeviceByIdAsync = () => useMutation(getDeviceByIdAsync);

export const useDeleteDeviceByIdAsync = () =>
  useMutation(deleteDeviceByIdAsync);

export const useGetAllDevicesByLicenseAsync = () =>
  useMutation(getAllDevicesByLicenseAsync);
export const useOpenDoorAsync = () =>
  useMutation(openDoor);
export const useGetAllCamsByLicenseAsync = () =>
  useMutation(getAllCamsByLicenseAsync);

export const useGetAllCamsByLicenseCountAsync = () =>
  useMutation(getAllCamsByLicenseCountAsync);

export const useGetAllControllersByLicenseAsync = () =>
  useMutation(getAllControllersByLicenseAsync);

export const useGetAllControllersByLicenseCountAsync = () =>
  useMutation(getAllControllersByLicenseCountAsync);

export const useGetAllDvrByLicenseAsync = () =>
  useMutation(getAllDvrByLicenseAsync);

export const useGetAllDvrByLicenseCountAsync = () =>
  useMutation(getAllDvrByLicenseCountAsync);

export const useGetAllByLicenseCountAsync = () =>
  useMutation(getAllDevicesByLicenseCountAsync);

export const useGetAllInternalFacesFromDeviceAsync = () =>
  useMutation(getAllInternalFacesFromDeviceAsync);

export const useGetAllInternalFacesFromDeviceCountAsync = () =>
  useMutation(getAllInternalFacesFromDeviceCountAsync);

export const useGetAllByLicenseInfoAsync = () =>
  useMutation(getAllDevicesByLicenseInfoAsync);

export const useGetNetworkConfigAsync = () =>
  useMutation(getNetworkConfigAsync);

export const useUpdateNetworkConfigAsync = () =>
  useMutation(updateNetworkConfigAsync);

export const useGetRecoverEventConfigAsync = () =>
  useMutation(getRecoverEventConfigAsync);

export const useUpdateRecoverEventConfigAsync = () =>
  useMutation(updateRecoverEventConfigAsync);

export const useGetNtpConfigAsync = () => useMutation(getNtpConfigAsync);

export const useUpdateNtpConfigAsync = () => useMutation(updateNtpConfigAsync);

export const useGetTimeConfigAsync = () => useMutation(getTimeConfigAsync);

export const useUpdateTimeConfigAsync = () =>
  useMutation(updateTimeConfigAsync);

export const useGetVideoConfigAsync = () => useMutation(getVideoConfigAsync);

export const useUpdateVideoConfigAsync = () =>
  useMutation(updateVideoConfigAsync);

export const useGetRecordingScheduleConfigAsync = () =>
  useMutation(getRecordingScheduleConfigAsync);

export const useUpdateRecordingScheduleConfigAsync = () =>
  useMutation(updateRecordingScheduleConfigAsync);

export const useUpdateLprGroupsConfigAsync = () =>
  useMutation(updateLprGroupsConfigAsync);

export const useGetLprGroupsConfigAsync = () =>
  useMutation(getLprGroupsConfigAsync);

export const useGetLostAlarmEventsConfigAsync = () =>
  useMutation(getLostAlarmEventsConfigAsync);

export const useCreateDeviceAsync = () => useMutation(createDeviceAsync);

export const useUpdateDeviceAsync = () => useMutation(updateDeviceAsync);

export const useUpdateDeviceExternalControlIdAsync = () =>
  useMutation(updateDeviceExternalControlIdAsync);

export const useSyncDeviceModuleHistoryAsync = () =>
  useMutation(syncDeviceModuleHistoryAsync);

export const useGetFacialSyncSelectableDevicesAsync = () =>
  useMutation(getFacialSyncSelectableDevicesAsync);

export const useSyncFacialRecognitionDevicesAsync = () =>
  useMutation(syncFacialRecognitionDevicesAsync);